'use strict';
(function () {
  angular.module('pentaApp').factory('getUserInformation.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/getUserInformation', null, { query: { isArray: false, cache: false } });
  }
})();